// extracted by mini-css-extract-plugin
export default {"-large":"x5DspqbDHRcfUTeHuKFH","container":"qeLzvsDkOR0CqQHAvyv7","icon":"__PjoMrzLAi_cB3UQURQ"};